var map = {
	"./img_0.png": 789,
	"./img_1.png": 790,
	"./img_10.png": 791,
	"./img_11.png": 792,
	"./img_2.png": 793,
	"./img_3.png": 794,
	"./img_4.png": 795,
	"./img_5.png": 796,
	"./img_6.png": 797,
	"./img_7.png": 798,
	"./img_8.png": 799,
	"./img_9.png": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;